import React, { FC, useCallback } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Account, Employee, SendMoneyState, Terminal } from '~/types';
import AccountAutocomplete from '~/pages/accounts/AccountAutocomplete';
import { useApi } from '~/hooks';
import { getAccounts } from '~/api/accounts';
import { getAllEmployees } from '~/api/employees';
import { getAllTerminals } from '~/api/terminals';

interface FromAccountProps {
  setMainState: React.Dispatch<React.SetStateAction<SendMoneyState>>;
  mainState: SendMoneyState;
}

const FromAccount: FC<FromAccountProps> = (props) => {
  const { setMainState, mainState } = props;
  const [t] = useTranslation('sendMoney');

  const [{ data: accounts, loading: accountsLoading }] = useApi<Account[]>(getAccounts);
  const [{ data: employees, loading: employeesLoading }] = useApi<Employee[]>(getAllEmployees);
  const [{ data: terminals, loading: terminalsLoading }] = useApi<Terminal[]>(getAllTerminals);
  const loading = accountsLoading || employeesLoading || terminalsLoading;

  const onChange = useCallback(
    (senderAccount: Account | undefined) => {
      setMainState((prev) => ({
        ...prev,
        senderAccount,
        senderAccountId: senderAccount?.id,
        senderAccountNumber: senderAccount?.number,
      }));
    },
    [setMainState]
  );

  return (
    <div>
      <Typography.Title level={4}>{t('fromAccount')}</Typography.Title>
      <AccountAutocomplete
        onChange={onChange}
        accountId={mainState.senderAccountId}
        loading={loading}
        accounts={accounts}
        terminals={terminals}
        employees={employees}
      />
    </div>
  );
};

export default FromAccount;
